import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../auth/AuthContext';

const UnauthorizedPage = () => {
  const { userInfo, logout, isWhitelisted, isAdmin } = useAuth();

  if (isWhitelisted || isAdmin) {
    return <Navigate to="/dashboard" replace />;
  }

  return (
    <main className="mp-access">
      <section className="mp-access-card">
        <img src="/magisprev-icon.png" width="56" height="56" alt="" />
        <p className="eyebrow">Acesso pendente</p>
        <h1>Aguardando autorização</h1>
        <p>
          Sua conta foi criada, mas ainda não foi autorizada a acessar o dashboard. Um
          administrador precisa aprovar o seu acesso.
        </p>

        {userInfo && (
          <div className="alert alert-info text-start mt-3 mb-0">
            <strong>E-mail:</strong> {userInfo.email}
          </div>
        )}

        <div className="d-grid gap-2">
          <button className="btn btn-primary" onClick={() => window.location.reload()}>
            Verificar novamente
          </button>
          <button className="btn btn-outline-secondary" onClick={logout}>
            Sair
          </button>
        </div>
      </section>
    </main>
  );
};

export default UnauthorizedPage;
